import Unsubscribe from 'components/pages/Unsubscribe/Unsubscribe';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('unsubscribe', {
  withoutHeader: true,
  withoutFooter: true,
});

export default buildPage(Unsubscribe, {
  fullPageWidth: true,
  metaData: {
    title: 'Contact Preferences',
    description: 'You can manage your contact preferences here',
  },
  loggedInRedirect: '/member/contact-preferences',
});
